import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe implements PipeTransform {
  transform(value: any): string {
    if (!value) {
      return '';
    }

    // Wenn es bereits ein String im deutschen Format ist, geben wir es zurück
    if (typeof value === 'string' && value.match(/^\d{2}\.\d{2}\.\d{4}$/)) {
      return value;
    }

    // Wenn es ein Date-Objekt oder ein String ist, konvertieren wir es
    const date = new Date(value);
    
    // Prüfen ob das Datum gültig ist
    if (isNaN(date.getTime())) {
      return value; // Falls das Datum ungültig ist, geben wir den ursprünglichen Wert zurück
    }

    // Formatieren als dd.mm.yyyy
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${day}.${month}.${year}`;
  }
}
